import client from './client';

// Admin binary identity, served by GET /api/version. The fields are
// injected at build time via -ldflags; built_at is RFC3339 UTC and
// the UI formats it client-side (Asia/Shanghai).
export interface AdminVersion {
  version: string;     // e.g. "v0.6.14-custom-dur"
  git_sha: string;     // short SHA like "27ccd7e"
  built_at: string;    // RFC3339 UTC, e.g. "2026-07-04T15:30:00Z" or "unknown"
  go_version: string;  // e.g. "go1.22.0"
  // Version of the agent binary that the install / node-upgrade flow
  // will push to every node. Read at admin startup from
  // /apps/rxjh-admin/agent_version (a sidecar file written by
  // deploy_admin.sh at install time). "unknown" if not yet set up.
  agent_version: string;
}

export async function getAdminVersion(): Promise<AdminVersion> {
  const res = await client.get(`/api/version?t=${Date.now()}`);
  return res.data;
}
